import {
  CLEAR_ADMIN_PAGINATION_STATE,
  GET_ADMIN_PAGINATION_STATE,
  SET_ACCOUNTS_PAGINATION_STATE,
  SET_USERS_PAGINATION_STATE,
  SET_EMAILTEMPLATES_PAGINATION_STATE,
} from "./AdminPaginationRowType";

const getAdminPaginationState = () => {
  return {
    type: GET_ADMIN_PAGINATION_STATE,
  };
};

const setAccountsPaginationState = (data) => {
  return {
    type: SET_ACCOUNTS_PAGINATION_STATE,
    payload: data,
  };
};
const setUsersPaginationState = (data) => {
  return {
    type: SET_USERS_PAGINATION_STATE,
    payload: data,
  };
};
const setEmailTemplatesPaginationState = (data) => {
  return {
    type: SET_EMAILTEMPLATES_PAGINATION_STATE,
    payload: data,
  };
};

const clearAdminPaginationState = (data) => {
  return {
    type: CLEAR_ADMIN_PAGINATION_STATE,
    payload: data,
  };
};
const AdminPaginationRowAction = {
  getAdminPaginationState,
  clearAdminPaginationState,
  setAccountsPaginationState,
  setUsersPaginationState,
  setEmailTemplatesPaginationState,
};
export default AdminPaginationRowAction;
